import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadAdminList } from '../../../actions/admin';
import { adminUserModalToggle } from '../../../actions/ui';

import './adminsuser.css'
import AdminDialog from './AdminDialog';
import AdminUserItem from './AdminUserItem';
import AdminUserModal from './AdminUserModal';

import { Stack, Grid, Alert, Fab, Container, Typography, LinearProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const openAdd = {
    status: true,
    action: 'add'
};

const AdminsUsersList = () => {
    const dispatch = useDispatch();
    const { admins } = useSelector(state => state.admin);
    
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
        dispatch(loadAdminList(setLoading));
    }, []);
    
    const addAdminUser = () => {
        dispatch(adminUserModalToggle(openAdd));
    };

    return (
        <>
            {
                loading ?
                    <Stack spacing={2}>
                        <Alert severity="info">
                            <Typography variant="h6" gutterBottom>
                                Cargando usuarios administradores...
                            </Typography>
                        </Alert>
                        <LinearProgress color="info" />
                    </Stack>
                :
                    <Container maxWidth='xl' sx={{ mt: '90px' }}>
                        <Typography variant='h5'
                            sx={{ fontWeight: 'light' }} paragraph>
                            Lista de administradores
                        </Typography>
                        {
                            admins.length > 0 ?
                                <Grid container spacing={4}>
                                    {
                                        admins.map(e =>
                                            <AdminUserItem key={e._id} admin={e} />
                                        )
                                    }
                                </Grid>
                            :
                                <Alert severity="warning">No hay administradores</Alert>
                        }
                    </Container>
            }

            <Fab color="primary"
                aria-label="add" sx={{
                    position: "fixed",
                    bottom: (theme) => theme.spacing(2),
                    right: (theme) => theme.spacing(2)
                }}
                onClick={addAdminUser}>
                <AddIcon />
            </Fab>
            <AdminUserModal />
            <AdminDialog />
        </>
    );
};

export default AdminsUsersList;
